import { WEB_LOOKUP, WEB_NEW_LOOKUP } from '@shared/config/constants/api-sources';

interface HlrlookupRoute {
  path: string;
  apiSource: string;
  phoneFormConfig?: Record<string, any>;
  bannerConfig?: Record<string, any>;
}

export const hlrlookupRoutes: HlrlookupRoute[] = [
  {
    path: '/hlrlookup/new',
    apiSource: WEB_NEW_LOOKUP,
  },
  {
    path: '/hlrlookup/new/:lang',
    apiSource: WEB_NEW_LOOKUP,
  },
  {
    path: '/hlrlookup/new/:lang/:country',
    apiSource: WEB_NEW_LOOKUP,
  },
  {
    path: '/hlrlookup/new/:lang/:country/:operator',
    apiSource: WEB_NEW_LOOKUP,
  },
  {
    path: '/hlrlookup/new/:lang/:country/:operator/:msisdn',
    apiSource: WEB_NEW_LOOKUP,
  },
  {
    path: '/hlrlookup',
    apiSource: WEB_LOOKUP,
  },
  {
    path: '/hlrlookup/:lang',
    apiSource: WEB_LOOKUP,
  },
  {
    path: '/hlrlookup/:lang/:country',
    apiSource: WEB_LOOKUP,
  },
  {
    path: '/hlrlookup/:lang/:country/:operator',
    apiSource: WEB_LOOKUP,
  },
  {
    path: '/hlrlookup/:lang/:country/:operator/:msisdn',
    apiSource: WEB_LOOKUP,
  },
];
